import ScalarFormInput_vue_vue_type_script_setup_true_lang_default from "./ScalarFormInput.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarForm/ScalarFormInput.vue
var ScalarFormInput_default = ScalarFormInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarFormInput_default as default };

//# sourceMappingURL=ScalarFormInput.vue.js.map